/**
 * Utility functions and definitions for debug
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

import { isEnvProduction } from "../api"

/**
 * Return true if debug mockup is set in VITE environment variables.
 */
export function isDebugMockup(): boolean {
  if (isEnvProduction) {
    // Always disable mockup in Production
    return false
  }

  if (!import.meta.env.VITE_DEBUG_MOCKUP)
    // Variable not found: disabled by default
    return false

  return import.meta.env.VITE_DEBUG_MOCKUP === 'true'
}
